// extracted by mini-css-extract-plugin
module.exports = {"textarea":"styles_textarea__15E5A"};